// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bago","top":"styles_top__K_PPn"};